import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { StockAlert } from "src/app/domain/models/StockAlert";

@Injectable({providedIn: 'root'})
export abstract class StockAlertGateway {
  abstract getStockAlert(stockId: number): Observable<StockAlert[]>
  abstract update(stockAlertGuid: string, review: boolean): Observable<any>
}
